import { GenerateTokenResponse } from "../api/auth";

export const generateTokenExample: GenerateTokenResponse = {
    access_token: "2a544ecdc952c5fa7a5772c23b0185851f9ad0d1",
    expires_in: 3600,
    token_type: "Bearer",
    scope: "fullAdmin",
    refresh_token: "a847ad77dd5f2ba4a3a52852567a193ac4582db5",
};
